





















import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {Grid} from '@toast-ui/vue-grid';
import {GridProps} from '@/types';
import {toI18n} from '@/utils/commonUtils';
import GridColumnsLayer from '@/components/common/grid/GridColumnsLayer.vue';
import {GridNameType} from 'supporter';
import { CommonColumnInfo } from '@/types/tui-grid/store/column';

interface PageObj {
  page: number;
}

@Component({
  components: {Grid, GridColumnsLayer}
})
export default class PageBottomContent extends Vue {
  @Prop({required: false, default: '', type: String})
  private readonly gridName?: string;
  @Prop({required: false, default: 'content_bottom_wrap', type: String})
  private readonly wrapClass?: string;
  @Prop({
    required: false,
    default: function () {
      return {};
    },
    type: Object
  })
  private readonly customColumnHeader?: {name: string; renderer: any}[];

  @Prop({required: true})
  private readonly gridProps!: GridProps;

  @Prop({
    required: false,
    default: function () {
      return {};
    },
    type: Object
  })
  private readonly gridOptions?: {[propName: string]: any};

  @Prop({required: true, default: () => []})
  private readonly data!: [];

  @Prop({required: false, default: false, type: Boolean})
  private readonly fireClick?: boolean;

  @Prop({required: false, default: '', type: String})
  private readonly tableTitle?: string;
  private currentTableTitle = this.toI18n('COMMON_VIEWRESULTS');

  @Watch('tableTitle')
  onTableTitleChange(newVal: string) {
    if (newVal) {
      this.currentTableTitle = newVal;
    }
  }

  get pageOptions() {
    return this.gridProps.pageOptions;
  }

  private showColumns: any = [];
  private columnsOrder: any = [];
  private defaultColumnsOrder: any = [];
  private disabledCnt = 0;

  private showEditLayer = false;

  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t(needToI18nStr));
  }

  public options = {
    header: {
      height: 33
    },
    columnOptions: {
      minWidth: 50
    },
    minRowHeight: 31,
    rowHeight: 31,
    bodyHeight: 190,
    useClientSort: false,
    pageOptions: {
      perPage: 30,
      page: 1,
      totalCount: 0,
      centerAlign: true,
    }
  };

  private bodyHeight = 480;

  @Watch('data')
  onDataChanged() {
    const grid = this.$refs.tuiGrid as Grid;
    grid.invoke('setBodyHeight', this.data.length === 0 ? 190 : this.bodyHeight);
    const pagination = grid.invoke('getPagination') as any;
    if (pagination) {
      const pageState = {
        totalCount: this.pageOptions.totalCount,
        page: this.pageOptions.page,
        perPage: this.pageOptions.perPage - 0
      };
      grid.invoke('resetData', this.data as any, {pageState});
    } else {
      grid.invoke('resetData', this.data as any);
    }

    this.$nextTick(() => {
      grid.invoke('refreshLayout');
    });
  }

  private getCheckedItems(propName: string) {
    const grid = this.$refs.tuiGrid as Grid;
    if (propName) {
      const items = grid.invoke('getCheckedRows').map((item) => item[propName]);
      return items.join(',');
    } else {
      return grid.invoke('getCheckedRows').map((item) => item);
    }
  }

  private onClick({targetType, rowKey, instance}: any) {
    if (!this.fireClick) return;
    if (targetType === 'cell') {
      const {radioBtn} = instance.store.column.allColumnMap;
      if (radioBtn) {
        const radio = $('.tui-grid-cell-current-row input[type="radio"]');
        radio.prop('checked', true);
        instance.uncheckAll();
        instance.check(rowKey);

        this.$emit('onClick', instance.getRow(rowKey));
      }
    }
  }

  private async created() {
    Object.assign(this.options, {rowHeaders: this.gridProps.rowHeaders || ['rowNum']});
    Object.assign(this.options.header, this.customColumnHeader);

    if (this.gridOptions && Object.keys(this.gridOptions) && this.gridOptions.constructor === Object) {
      if (this.gridOptions.bodyHeight) {
        this.bodyHeight = this.gridOptions.bodyHeight;
      }
      Object.assign(this.options, this.gridOptions);
    }

    const currentGridColumns = JSON.parse(JSON.stringify(this.gridProps.columns));
    if (this.gridName) {
      if (this.gridOptions.id === 'tui-grid-productlist') {
        const {data: customPropertyData} = await this.$api.getCustomPropertyUsable();
        const propertyNames = customPropertyData
          .filter((item: any): boolean => item.used)
          .map(({propertyNo, propertyName}) => {
            return {
              header: propertyName,
              name: `customProperties${propertyNo}`
            };
          });

        propertyNames.forEach((column: any): void => {
          currentGridColumns.splice(currentGridColumns.length - 1, 0, column);
        });
      }

      this.defaultColumnsOrder = currentGridColumns.map((column: any, idx: number) => {
        return {
          columnName: column.name,
          displayOrder: idx + 1,
          visible: column.hidden ? !column.hidden : true,
          showName: column.header
        };
      });

      if (this.gridOptions.columnOptions && this.gridOptions.columnOptions.frozenCount) {
        this.disabledCnt = this.gridOptions.columnOptions.frozenCount;
      }

      const {data} = await this.$api.getGridLayouts({params: {gridName: this.gridName as GridNameType}});
      if (data?.length) {
        data.forEach((layoutInfo: any) => {
          let tempColumn = currentGridColumns.find((column: any) => layoutInfo.columnName === column.name);
          
          if (tempColumn) {
            if(layoutInfo.columnName=== 'mainImageUrl') {
              const mainImageColumn = this.gridProps.columns.find(({name}: {name: string}) => name === 'mainImageUrl') as CommonColumnInfo;
              const foundIdx = this.gridProps.columns.findIndex(({name}: {name: string}) => name === 'mainImageUrl');
              
              Vue.set( this.gridProps.columns, foundIdx, {...mainImageColumn, hidden: !layoutInfo.visible})
            }

            if (layoutInfo.visible) {
              this.showColumns.push(tempColumn);
            }

            this.columnsOrder.push({
              columnName: layoutInfo.columnName,
              displayOrder: layoutInfo.displayOrder,
              visible: layoutInfo.visible,
              showName: (tempColumn as any).header
            });
          }
        });

        if (this.columnsOrder.length < currentGridColumns.length) {
          currentGridColumns.forEach((column: any) => {
            if (this.columnsOrder.every((layoutInfo: any) => layoutInfo.columnName !== column.name)) {
              this.showColumns.push(column);
              this.columnsOrder.push({
                columnName: column.name,
                displayOrder: this.columnsOrder.length + 1,
                visible: column.hidden ? !column.hidden : true,
                showName: column.header
              });
            }
          });
        }
      } else {
        this.showColumns = currentGridColumns;
        this.columnsOrder = JSON.parse(JSON.stringify(this.defaultColumnsOrder));
      }
    } else {
      this.showColumns = currentGridColumns;
    }
  }

  private mounted() {
    const grid = this.$refs.tuiGrid as Grid;
    const pagination = grid.invoke('getPagination');
    if (pagination) {
      grid.invoke('on', 'beforePageMove', (ev: any) => {
        this.$emit('searchBtnClick', ev.page);
        ev.stop();
      });
    }

    grid.invoke('on', 'mousedown', (ev: any) => {
      if (ev.targetType === 'columnHeader') {
        $('th[data-column-name="' + ev.columnName + '"]').removeClass('tui-grid-cell-selected');
      }
      let tagName = ev.nativeEvent.target.tagName;
      if (tagName === 'SELECT' || tagName === 'INPUT') {
        ev.stop();
      }
    });
  }
}
